import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Recuperacao } from '../../shared';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';

declare var $: any;

@Component({
  selector: 'app-exibir-codigo-chave',
  templateUrl: './exibir-codigo-chave.component.html',
  styleUrls: ['./exibir-codigo-chave.component.css']
})
export class ExibirCodigoChaveComponent implements OnInit {

  @Input() novoCodigoChave: string = "";
  @Output() enviaMensagemSucesso = new EventEmitter();
  public errorMessage: string;
  
  constructor(private usuarioService: UsuarioService) {

  }

  ngOnInit() {

  }

  enviarPorEmail() {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let recuperacao: Recuperacao = new Recuperacao();
    recuperacao.codigoChave = this.novoCodigoChave;

    this.usuarioService.enviarEmailCodigoChave(currentUser.id, recuperacao).subscribe(
      () => {
        this.fechar();
        this.enviaMensagemSucesso.emit("E-mail enviado com sucesso!");
      },
      (err) => {
        this.errorMessage = err.message;
      }
    );
  }

  fechar() {
    $('#modalExibirCodigoChave').modal('toggle');
  }
}